import { z } from 'zod';

// Reordenação de áreas/itens reutiliza ReorderBodySchema de ./desks.

export const CatalogSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  active: z.boolean(),
});
export type Catalog = z.infer<typeof CatalogSchema>;

export const CatalogAreaSchema = z.object({
  id: z.number().int(),
  catalogId: z.number().int(),
  name: z.string(),
  position: z.number().int(),
});
export type CatalogArea = z.infer<typeof CatalogAreaSchema>;

export const CatalogItemSchema = z.object({
  id: z.number().int(),
  areaId: z.number().int(),
  name: z.string(),
  description: z.string().nullable(),
  /** metas de SLA do item; null = herda da prioridade do ticket */
  attendMinutes: z.number().int().nullable(),
  solveMinutes: z.number().int().nullable(),
  position: z.number().int(),
  active: z.boolean(),
});
export type CatalogItem = z.infer<typeof CatalogItemSchema>;

export const CatalogAreaDetailSchema = CatalogAreaSchema.extend({
  items: z.array(CatalogItemSchema),
});
export type CatalogAreaDetail = z.infer<typeof CatalogAreaDetailSchema>;

/** GET /catalogs/:id — árvore completa catálogo → áreas → itens. */
export const CatalogDetailSchema = CatalogSchema.extend({
  areas: z.array(CatalogAreaDetailSchema),
});
export type CatalogDetail = z.infer<typeof CatalogDetailSchema>;

export const CatalogCreateBodySchema = z.object({
  name: z.string().min(1),
});
export type CatalogCreateBody = z.infer<typeof CatalogCreateBodySchema>;

export const CatalogPatchBodySchema = z
  .object({
    name: z.string().min(1),
    active: z.boolean(),
  })
  .partial()
  .strict();
export type CatalogPatchBody = z.infer<typeof CatalogPatchBodySchema>;

export const CatalogAreaBodySchema = z.object({
  name: z.string().min(1),
});
export type CatalogAreaBody = z.infer<typeof CatalogAreaBodySchema>;

export const CatalogItemBodySchema = z.object({
  name: z.string().min(1),
  description: z.string().nullish(),
  attendMinutes: z.number().int().positive().nullish(),
  solveMinutes: z.number().int().positive().nullish(),
  active: z.boolean().optional(),
});
export type CatalogItemBody = z.infer<typeof CatalogItemBodySchema>;

/** PUT /desks/:id/catalogs — substitui o conjunto de catálogos vinculados. */
export const DeskCatalogsPutBodySchema = z.object({
  catalogIds: z.array(z.number().int().positive()),
});
export type DeskCatalogsPutBody = z.infer<typeof DeskCatalogsPutBodySchema>;
